import { ButtonLink } from "~/shared/components/ds/ButtonLink";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { PARTICIPANT_PATHS } from "~/team/constants/paths.constants";

export function ParticipantNotFound() {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Can&apos;t find participant</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            We couldn&apos;t find this participant in the system. Check the participant list to find the right person,
            or try reloading the page
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>
          <ButtonLink variant="default" to={PARTICIPANT_PATHS.root}>
            Go to Participants
          </ButtonLink>
        </ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}
